import { config } from './config';

const POLL_INTERVAL_MS = 30_000;
const VERSION_RE = /appVersion:\s*["']([^"']+)["']/;

let bootVersion = config.appVersion;
let latestVersion = bootVersion;
let pending = false;
const listeners = new Set<(latest: string) => void>();

async function fetchRemoteVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/config.js?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const text = await res.text();
    const match = VERSION_RE.exec(text);
    return match?.[1] ?? null;
  } catch {
    return null;
  }
}

async function poll(): Promise<void> {
  const remote = await fetchRemoteVersion();
  if (!remote) return;
  latestVersion = remote;
  if (!pending && remote !== bootVersion) {
    pending = true;
    listeners.forEach((fn) => fn(remote));
  }
}

export function startVersionWatcher(): void {
  // 'dev' is the placeholder in public/config.js for local builds — skip polling there.
  if (bootVersion === 'dev') return;
  window.setInterval(() => void poll(), POLL_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void poll();
  });
}

export function onVersionUpdateAvailable(fn: (latest: string) => void): void {
  listeners.add(fn);
  if (pending) fn(latestVersion);
}

export function isUpdatePending(): boolean {
  return pending;
}

export function reloadForUpdate(): void {
  window.location.reload();
}
